import { type ResultOf } from '@graphql-typed-document-node/core'
import { useMutation, type UseMutationOptions } from '@tanstack/react-query'

import { graphql } from '~/gql'
import { useGraphQLRequest } from '~/hooks/useGraphQLRequest'

const document = graphql(`
  mutation CustomerAttributeListPage_DeleteCustomerAttributeBulk(
    $customerAttributeIds: [ID!]!
  ) {
    deleteCustomerAttributeBulk(customerAttributeIds: $customerAttributeIds) {
      result
    }
  }
`)

export const useDeleteCustomerAttributeBulkMutation = (
  options: Omit<
    UseMutationOptions<ResultOf<typeof document>, unknown, string[], unknown>,
    'mutationFn'
  > = {},
) => {
  const graphQLRequest = useGraphQLRequest()

  return useMutation({
    mutationFn: (customerAttributeIds) =>
      graphQLRequest({ document, variables: { customerAttributeIds } }),
    ...options,
  })
}
